import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSkullCrossbones = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 7H10.01M14 7H14.01M3 14L21 21M21 14L3 21M18 8.5C18 5.46243 15.3137 3 12 3C8.68629 3 6 5.46243 6 8.5C6 9.50179 8.48949 10.441 9 11.25C9.70984 12.3748 9 14 10 14C10 14 11.2987 14 12 14C12.7013 14 13.5 14 14 14C15 14 14.2902 12.3748 15 11.25C15.5105 10.441 18 9.50179 18 8.5Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSkullCrossbones;
